import styled from "styled-components";

import { theme } from "../../themes/themes";
export const AddSubPolicyContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: grid;
  grid-template-columns: 10% 40% 40% 10%;
  padding: 10px;
  justify-items: center;
  align-items: center;

  .deleteIcon {
    display: flex;
    position: relative;
    top: 10px;
    align-items: center;
  }

  .MuiSvgIcon-root {
    height: 20px !important;
  }

  @media only screen and (min-width: 800px) and (max-width: 1485px) {
    grid-template-columns: 8% 35% 35% 22%;
  }

  @media only screen and (min-width: 651px) and (max-width: 800px) {
    grid-template-columns: 6% 35% 35% 24%;
  }
  @media only screen and (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;
export const SubPolicy = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  input {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    padding: 9px;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
    outline: none;
  }
`;

export const LOB = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
`;

export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? "#ffbbdc33" : theme.neutral.gray[700],
    borderColor: theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: "#ffbbdc33",
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#ffbbdc33" : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: "#ffbbdc33",
      },
      color: isFocused ? theme.button.primary : data.color,
    };
  },
};

export const SubPolicyLabel = styled.div`
  label {
    font-weight: 700;
  }
  svg {
    margin: 10px;
  }
`;
